import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";

import errorSent from "~/utils/errors/errorSent";
import { withHttpSpan } from "~/utils/errors/withHttpSpan";
import { logError, logTime } from "~/utils";

const request = async (
  method: "get" | "post",
  url: string,
  dataOrConfig?: any,
  configOrUndefined?: AxiosRequestConfig,
): Promise<any> => {
  const start = Date.now();

  let response: AxiosResponse;
  const config = method === "get" ? dataOrConfig : configOrUndefined;
  try {
    response = await withHttpSpan(method, url, async () => {
      if (method === "get") {
        return axios.get(url, config);
      }
      return axios.post(url, dataOrConfig, config);
    });

    const elapsed = Date.now() - start;

    // page-meta-tracking — фоновая отправка меты, её ответа никто не ждёт,
    // а она давала почти все slowResponse.
    if (
      elapsed > 10000 &&
      !url.includes("clear_cache") &&
      !url.includes("page-meta-tracking")
    ) {
      errorSent("apiCallError", "slowResponse", {
        elapsed,
        url,
        method,
        status: response.status,
      });
    }

    logTime(start, `[axiosWrapper] ${method.toUpperCase()} ${url}`);
    return response;
  } catch (error: unknown) {
    logTime(start, `[axiosWrapper] ERROR ${method.toUpperCase()} ${url}`);
    logError("axiosWrapper error", {
      url,
      method,
      config,
      data: method === "post" ? dataOrConfig : undefined,
      error,
    });
    errorSent(
      "apiCallError",
      "wrongResponseCode",
      {
        url,
        method,
        // Статус нужен для fingerprint — иначе разные коды ответа одного URL
        // попадают в одну issue (см. getApiFingerprint).
        status: (error as any)?.response?.status,
      },
      error instanceof Error ? error : null,
    );
  }
  return {
    data: null,
  };
};

export const axiosWrapper = {
  get: (url: string, config?: AxiosRequestConfig) =>
    request("get", url, config),

  post: (url: string, data?: any, config?: AxiosRequestConfig) =>
    request("post", url, data, config),
};
